import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _trainers = [];

let TrainerStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return {remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _trainers.filter(function(e) { return e !== undefined; });
    },
    
    add: function(trainer) {
        if (trainer !== undefined && !!trainer.id) {
            trainer.userId = Number(trainer.id);
            let trainerIndex = _trainers.findIndex(function(e) { return e !== undefined && e.id == trainer.id; });
            if (0 <= trainerIndex) {
                // it's probably more up to date
                _trainers[trainerIndex] = trainer;
            } else {
                _trainers.push(trainer);
            }
        }
    },

});

TrainerStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.TRAINER_LIST:
            if (action.data instanceof Array) {
                action.data.forEach(TrainerStore.add);
            } else {
                TrainerStore.add(action.data);
            }
            TrainerStore.emitChange();
            break;

        case ActionTypes.TRAINER_LIST_ERROR:
            // report error
            TrainerStore.emitChange();
            break;
            
        default:
            break;
    }

});

export default TrainerStore;
